import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=1f79daf6"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pforret/Code/Movix/laravel/showtimes.movix/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f79daf6')) {
      api.createRecord('1f79daf6', component.options)
    } else {
      api.reload('1f79daf6', component.options)
    }
    module.hot.accept("./Dashboard.vue?vue&type=template&id=1f79daf6", function () {
      api.rerender('1f79daf6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/Dashboard.vue"
export default component.exports